import React from 'react';
import Lottie from 'lottie-react';
import loadingBookAnimation from '../lottie/loading-book.json';
import { LOTTIE_SIZES, lottieFrameStyle, lottieContentStyle } from './common/lottieSizing';

interface LoadingBookProps {
  size?: number;
  style?: React.CSSProperties;
}

const LoadingBook: React.FC<LoadingBookProps> = ({ size = LOTTIE_SIZES.loading, style }) => {
  return (
    <div style={{ ...lottieFrameStyle(size), ...style }}>
      <Lottie
        animationData={loadingBookAnimation}
        loop
        autoplay
        style={lottieContentStyle}
      />
    </div>
  );
};

export default LoadingBook;
